export const TestIds = {
  linkButton: 'linkButton',
  linkInput: 'linkInput',
  linkUpdate: 'linkUpdate',
  linkCancel: 'linkCancel',
  linkRemove: 'linkCancel',
  textSizeButton: 'textSizeButton',
  boldButton: 'boldButton',
  italicButton: 'italicButton',
  alignButton: 'alignButton',
  underlineButton: 'underlineButton',
  orderedListButton: 'orderedListButton',
  unOrderedListButton: 'unOrderedListButton',
  scroller: 'scroller',
  label: 'label',
} as const;

export const TranslationKeys = {
  toolbar: {
    boldPc: 'rich_text_box_toolBar_bold_PC_UoU',
    boldMac: 'rich_text_box_toolBar_bold_mac_UoU',
    italicPc: 'rich_text_box_toolBar_italic_PC_UoU',
    italicMac: 'rich_text_box_toolBar_italic_mac_UoU',
    underlinePc: 'rich_text_box_toolBar_underline_PC_UoU',
    underlineMac: 'rich_text_box_toolBar_underline_mac_UoU',
    normalText: 'rich_text_box_toolbar_normal_text_UoU',
    normalTextPc: 'rich_text_box_toolBar_normal_text_PC_UoU',
    normalTextMac: 'rich_text_box_toolBar_normal_text_mac_UoU',
    title: 'rich_text_box_toolbar_title_UoU',
    titlePc: 'rich_text_box_toolBar_title_PC_UoU',
    titleMac: 'rich_text_box_toolBar_title_mac_UoU',
    subtitle: 'rich_text_box_toolbar_subtitle_UoU',
    subtitlePc: 'rich_text_box_toolBar_subtitle_PC_UoU',
    subtitleMac: 'rich_text_box_toolBar_subtitle_mac_UoU',
    linkPc: 'rich_text_box_toolBar_link_PC_UoU',
    linkMac: 'rich_text_box_toolBar_link_mac_UoU',
    align: 'rich_text_box_toolbar_align',
    alignRightPc: 'rich_text_box_toolbar_right_align_PC_UoU',
    alignRightMac: 'rich_text_box_toolbar_right_align_mac_UoU',
    alignLeftPc: 'rich_text_box_toolbar_left_align_PC_UoU',
    alignLeftMac: 'rich_text_box_toolbar_left_align_mac_UoU',
    alignCenterPc: 'rich_text_box_toolbar_center_align_PC_UoU',
    alignCenterMac: 'rich_text_box_toolbar_center_align_mac_UoU',
    alignJustifyPc: 'rich_text_box_toolbar_justify_PC_UoU',
    alignJustifyMac: 'rich_text_box_toolbar_justify_mac_UoU',
    numberedListPc: 'rich_text_box_toolbar_numbered_list_PC_UoU',
    numberedListMac: 'rich_text_box_toolBar_numbered_list_mac_UoU',
    bulletedListPc: 'rich_text_box_toolbar_bulleted_list_PC_UoU',
    bulletedListMac: 'rich_text_box_toolBar_bulleted_list_mac_UoU',
    linkLabel: 'rich_text_box_link_modal_label_UoU',
    linkPlaceholder: 'rich_text_box_link_modal_placeholder_UoU',
    linkCheckbox: 'rich_text_box_link_modal_checkbox_UoU',
    linkUpdateButton: 'rich_text_box_link_modal_update_button_UoU',
    linkCancelButton: 'rich_text_box_link_modal_cancel_button_UoU',
  },
} as const;
